var map = {
	"./light/sport/04sportDesc/08race.png": "jij9"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "X4P+";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme ^\.\/.*\/sport\/04sportDesc\/08race\.png$
// module id = X4P+
// module chunks = 0